module.exports = __webpack_public_path__ + "static/merch1Back-cc45e85696368255e840109469fd93fb.png";